<div class="w-full p-6">
    <!-- Header -->
    <div class="flex justify-between items-center mb-6">
        <div>
            <h2 class="text-2xl font-bold text-gray-900">Edit Company Admin</h2>
            <p class="text-sm text-gray-600 mt-1">Update admin details as super admin</p>
        </div>
        <button mat-icon-button (click)="onCancel()" class="text-gray-500 hover:text-gray-700">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <form [formGroup]="adminForm" (ngSubmit)="onSubmit()" class="space-y-4">
        <!-- Current Admin Info -->
        <div class="bg-gray-50 rounded-lg p-4 mb-4">
            <div class="text-sm text-gray-600 mb-2">Current Admin Details:</div>
            <div class="grid grid-cols-2 gap-3">
                <div>
                    <div class="text-xs text-gray-500">Current Name</div>
                    <div class="font-medium">{{ data?.admin?.name || 'N/A' }}</div>
                </div>
                <div>
                    <div class="text-xs text-gray-500">Current Email</div>
                    <div class="font-medium">{{ data?.admin?.email || 'N/A' }}</div>
                </div>
                <div>
                    <div class="text-xs text-gray-500">Current Company</div>
                    <div class="font-medium">
                        {{ data?.admin?.company?.name || data?.admin?.companyName || 'N/A' }}
                    </div>
                </div>
                <div>
                    <div class="text-xs text-gray-500">Role</div>
                    <div class="font-medium">{{ data?.admin?.role || 'admin' }}</div>
                </div>
            </div>
        </div>

        <!-- Name -->
        <mat-form-field class="w-full">
            <mat-label>Full Name *</mat-label>
            <input matInput formControlName="name" required />
            <mat-error *ngIf="adminForm.get('name')?.hasError('required')">
                Name is required
            </mat-error>
        </mat-form-field>

        <!-- Email -->
        <mat-form-field class="w-full">
            <mat-label>Email Address</mat-label>
            <input matInput formControlName="email" type="email" />
            <mat-hint>Email cannot be changed after account creation.</mat-hint>
        </mat-form-field>

        <!-- Company -->
        <mat-form-field class="w-full">
            <mat-label>Company Name</mat-label>
            <input matInput formControlName="companyName" />
            <mat-hint>Enter the company name for this admin</mat-hint>
        </mat-form-field>

        <!-- Important Note -->
        <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-2">
            <div class="flex items-start">
                <mat-icon class="text-blue-600 mr-2 mt-0.5" style="font-size: 20px">info</mat-icon>
                <div class="text-sm text-blue-700">
                    <p class="font-medium mb-1">Super Admin Permissions</p>
                    <p>
                        As a super admin, you can update only the name and company fields. Email,
                        role, phone, and password cannot be modified from here.
                    </p>
                </div>
            </div>
        </div>

        <!-- Actions -->
        <div class="flex justify-end gap-3 mt-6 pt-6 border-t">
            <button mat-button type="button" (click)="onCancel()" [disabled]="isLoading">
                Cancel
            </button>
            <button
                mat-flat-button
                type="submit"
                color="primary"
                [disabled]="isLoading || adminForm.invalid"
            >
                <span *ngIf="!isLoading">Update Admin</span>
                <span *ngIf="isLoading">Updating...</span>
            </button>
        </div>
    </form>
</div>
